import * as moment from 'moment'

export default {
  methods: {
    formatDate: function (date, add_days = null) {
      const lang = this.$store.state.user.language
      let format
      if (lang === 'pt') {
        moment.locale('pt-BR')
        format = 'DD/MM/YYYY'
      } else {
        moment.locale('en-US')
        format = 'MMM Do YYYY'
      }
      const obj = moment(date)
      if (add_days) obj.add(add_days, 'day')
      return obj.format(format)
    },
    formatDateUnix: function (date, add_days = null) {
      const lang = this.$store.state.user.language
      let format
      if (lang === 'pt') {
        moment.locale('pt-BR')
        format = 'DD/MM/YYYY'
      } else {
        moment.locale('en-US')
        format = 'MMM Do YYYY'
      }
      const obj = moment.unix(parseInt(date, 10))
      if (add_days) obj.add(add_days, 'day')
      return obj.format(format)
    }
  }
}
